import { useEffect, useState } from 'react';

import { CareProfileFragment as CareProfile } from '@typing/Generated';
import { BackOrNext } from '@typing/Models';

type Props = {
  handleBack: () => void;
  onUpdate: (careProfile?: CareProfile | null | undefined) => void;
};

const useBackOrNext = ({ handleBack, onUpdate }: Props) => {
  const [backOrNext, setBackOrNext] = useState<BackOrNext | null>(null);

  useEffect(() => {
    if (backOrNext !== null) {
      if (backOrNext === BackOrNext.NEXT) {
        onUpdate();
      } else {
        handleBack();
      }
      setBackOrNext(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [backOrNext]);

  return setBackOrNext;
};

export default useBackOrNext;
